"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.useMaasKeycloak = void 0;

var _react = _interopRequireDefault(require("react"));

var _web = require("@react-keycloak/web");

var _keycloakJs = _interopRequireDefault(require("keycloak-js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MaasKeycloak = function MaasKeycloak(_ref) {
  var children = _ref.children,
      initConfig = _ref.initConfig,
      config = _ref.config,
      LoadingComponent = _ref.LoadingComponent,
      authClient = _ref.authClient;
  var keycloakConfig = {
    url: (config === null || config === void 0 ? void 0 : config.url) || process.env.REACT_APP_KEYCLOAK_URL || '',
    realm: (config === null || config === void 0 ? void 0 : config.realm) || process.env.REACT_APP_KEYCLOAK_REALM || '',
    clientId: (config === null || config === void 0 ? void 0 : config.clientId) || process.env.REACT_APP_KEYCLOAK_CLIENT_ID || ''
  };

  if (!authClient) {
    if (!keycloakConfig.url) throw Error('url is required');
    if (!keycloakConfig.realm) throw Error('realm is required');
    if (!keycloakConfig.clientId) throw Error('clientId is required');
  }

  var keycloak = authClient || (0, _keycloakJs["default"])(keycloakConfig);

  var INIT_CONFIG = _objectSpread(_objectSpread({}, initConfig), {}, {
    checkLoginIframe: (initConfig === null || initConfig === void 0 ? void 0 : initConfig.checkLoginIframe) || false,
    onLoad: (initConfig === null || initConfig === void 0 ? void 0 : initConfig.onLoad) || 'login-required'
  });

  return /*#__PURE__*/_react["default"].createElement(_web.ReactKeycloakProvider, {
    LoadingComponent: LoadingComponent,
    authClient: keycloak,
    initOptions: INIT_CONFIG
  }, children);
};

var useMaasKeycloak = _web.useKeycloak;
exports.useMaasKeycloak = useMaasKeycloak;
var _default = MaasKeycloak;
exports["default"] = _default;